import React from "react";
import { Link, useLocation } from "react-router-dom";

const menuItems = [
  { to: "/airbnb-cleaning/", label: "Airbnb Property Management" },
  { to: "/residential-cleaning/", label: "Residential Cleaning" },
  { to: "/office-cleaning/", label: "Office Cleaning" },
  { to: "/school-and-medical-cleaning/", label: "School And Medical Cleaning" },
  { to: "/bond-cleaning/", label: "Bond Cleaning" },
  { to: "/window-cleaning/", label: "Window Cleaning" },
  { to: "/special-event-cleaning/", label: "Special Event Cleaning" },
  { to: "/carpet-steam-cleaning/", label: "Carpet Steam Cleaning" },
  { to: "/spring-cleaning/", label: "Spring Cleaning" },

  // godern-service
  { to: "/airbnb-cleaning-gold-coast/", label: "Airbnb Cleaning Gold Coast" },
  {
    to: "/apartment-cleaning-gold-coast/",
    label: "Apartment Cleaning Gold Coast",
  },
  { to: "/bond-cleaning-gold-coast/", label: "Bond Cleaning Gold Coast" },
  { to: "/carpet-cleaning-gold-coast", label: "Carpet Cleaning Gold Coast" },
  {
    to: "/commercial-cleaning-gold-coast/",
    label: "Commercial Cleaning Gold Coast",
  },
  { to: "/deep-cleaning-gold-coast/", label: "Deep Cleaning Gold Coast" },
  { to: "/housekeeping-services/", label: "Housekeeping Services Gold Coast" },
  { to: "/move-in-cleaning-gold-coast/", label: "Move In Cleaning Gold Coast" },
  {
    to: "/move-out-cleaning-gold-coast/",
    label: "Move Out Cleaning Gold Coast",
  },
  {
    to: "/residential-cleaning-gold-coast/",
    label: "Residential Cleaning Gold Coast",
  },
  {
    to: "/restaurant-cleaning-gold-coast/",
    label: "Restaurant Cleaning Gold Coast",
  },
  { to: "/spring-cleaning-gold-coast/", label: "Spring Cleaning Gold Coast" },
  { to: "/urgent-cleaning-service/", label: "Urgent Cleaning Gold Coast" },
];

const Menu = () => {
  const location = useLocation();

  return (
    <div className="col-xl-3 col-lg-4 col-md-5">
      <div className="widget sidebar-widget ext-sidebar-menu widget_nav_menu">
        <ul className="menu">
          {menuItems.map((item, index) => (
            <li
              key={index}
              className={location.pathname === item.to ? "active" : ""}
            >
              <Link
                onClick={() => {
                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "auto",
                  });
                }}
                to={item.to}
              >
                {item.label}
              </Link>{" "}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Menu;
